import React from "react";
import styled from "styled-components";
import reservImage from '../../assets/images/reserv-icon.png';
import {device} from "../../assets/styles/media";
import Bullet from "../atoms/Bullet";

const Contents = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 40px 60px;
    background: ${({bgColor}) => bgColor ? bgColor : "#fffbf2"};
    width: 100%;
    box-sizing: border-box;
    ${device.tablet} {
        box-sizing: border-box;
        margin: 25px 0;
        padding: 40px;
    }

    ${device.mobile} {
        width: 100%;
        box-sizing: border-box;
        padding: 30px 25px;

        &::before {
            zoom: 0.85;
        }
    }
`;
const Icon = styled.span`
    min-width: 15%;
    &::after {
        background-image: url(${reservImage});
        background-size: 100px, 100px;
        background-position: 0 0;
        width: 100px;
        height: 100px;
        content: "";
        display: inline-block;
    }
    
    ${device.pc} {
        min-width: 15%;
    }
    ${device.tablet} {
        min-width: 25%;
    }
    ${device.mobile} {
       zoom: 0.6;
    }

`;
const List = styled.ul`
    width: 90%;

    box-sizing: border-box;
    li:last-child {
        padding-bottom: 0;
    }
    ${device.pc} {
        width: 85%;
    }

    ${device.tablet} {
        display: flex;
        flex-direction: column;
        width: 75%;
    }

    ${device.mobile} {
        width: 75%;
    }

`;
const Li = styled.li`
    padding-bottom: 8px;
    padding-left: 12px;
    color: #414141;
    line-height: 26px;
    font-weight: 500;
 
    p{
        white-space: pre-wrap;
        line-height: 1.7;
    }

    span {
        color: #ed8e0c;
        font-size: 16px;
        display: block;

        ${device.tablet} {
            letter-spacing: -0.8px;
            line-height: 1.3;
        }

        ${device.mobile} {
            font-size: 13px;
            letter-spacing: -0.8px;
        }
    }

    ${device.mobile} {
        line-height: 20px;
    }
`;



const NoticeBox = ({list, bgColor}) => {
    return (
        <Contents bgColor={bgColor}>
            <Icon />
            <List>
                {list.map((item, index) => {
                    if(item.isSpecial) {
                        return (
                            <Li key={index}>
                                <Bullet style={{ whiteSpace: 'pre-wrap' }}>
                                    <strong>{item.item[0]}</strong>
                                    {item.item[1]}
                                    <strong>{item.item[2]}</strong>
                                    {item.item[3]}
                                </Bullet>
                            </Li>
                        );
                    }else {
                        if (Array.isArray(item.item) && item.bold) {
                            return (
                                <Li key={index}>
                                    <Bullet>
                                        {item.item[0]}
                                        <strong>{item.bold}</strong>
                                        {item.item[1]}
                                    </Bullet>
                                </Li>
                            );
                        } else {
                            return (
                                <Li key={index}>
                                    <Bullet>{item.item}</Bullet>
                                    {item.desc && <span>{item.desc}</span>}
                                </Li>
                            );
                        }
                    }
                })}
            </List>
        </Contents>
    );
};

export default NoticeBox;
